import { useContext, useEffect } from 'react';
import { ThemeContext } from './ThemeContext';
import { DARK_THEME, readPersistedTheme, LIGHT_THEME } from './themeClasses';

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) {
    throw new Error('useTheme must be used within a <ThemeProvider>');
  }
  return ctx;
}

/**
 * Force the dark theme while a component is mounted, then restore the visitor's
 * stored preference on unmount. Ported from `LogoComponent` ngOnInit/ngOnDestroy.
 */
export function useForceDarkTheme(): void {
  const { setTheme } = useTheme();
  useEffect(() => {
    setTheme(DARK_THEME);
    return () => {
      setTheme(readPersistedTheme() ?? LIGHT_THEME);
    };
  }, [setTheme]);
}
